var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("DialogLayout", {
    attrs: { title: "詳細情報", visible: _vm.dialogVisible, width: "65em" },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      open: _vm.open
    },
    scopedSlots: _vm._u([
      {
        key: "form",
        fn: function() {
          return [
            _c("RegistrationSymbolMasterForm", {
              ref: "registrationSymbolForm",
              attrs: {
                "label-width": "10em",
                formMode: "edit",
                "autocomplete-owner-code-set": _vm.autocompleteOwnerCodeSet,
                "autocomplete-model-code-set": _vm.autocompleteModelCodeSet
              },
              model: {
                value: _vm.registrationSymbolFormModel,
                callback: function($$v) {
                  _vm.registrationSymbolFormModel = $$v
                },
                expression: "registrationSymbolFormModel"
              }
            })
          ]
        },
        proxy: true
      },
      {
        key: "footer",
        fn: function() {
          return [_c("EditDialogFooter", { on: { update: _vm.clickUpdate } })]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }